import {
  CampaignProductsStatisticsActions,
  REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS,
  REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE,
  REQUEST_CAMPAIGNPRODUCTSTATISTICS,
  REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE
} from "./types";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";
import { CampaignProductsStatistics } from "../../../models/Statistics";
import { CampaignTargetUserType } from "../../../models/Campaign";

function fetchCampaignProductsStatistics(): CampaignProductsStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNPRODUCTSTATISTICS,
    payload: []
  };
}

function fetchCampaignProductsStatisticsDone(
  campaignProductStatistics: ReadonlyArray<CampaignProductsStatistics>
): CampaignProductsStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNPRODUCTSTATISTICS_DONE,
    payload: campaignProductStatistics
  };
}

function fetchCampaignComparisonProductsStatistics(): CampaignProductsStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS,
    payload: []
  };
}

function fetchCampaignComparisonProductsStatisticsDone(
  campaignProductStatistics: ReadonlyArray<CampaignProductsStatistics>
): CampaignProductsStatisticsActions {
  return {
    type: REQUEST_CAMPAIGNCOMPARISON_PRODUCTSTATISTICS_DONE,
    payload: campaignProductStatistics
  };
}

/* Thunks goes here */
export const thunkFetchCampaignProductsStatistics = (
  periodFrom: Date,
  periodTo: Date,
  campaignId: string,
  targetUserType: CampaignTargetUserType,
  compare: boolean
) => async (dispatch: any) => {
  try {
    dispatch(
      !compare
        ? fetchCampaignProductsStatistics()
        : fetchCampaignComparisonProductsStatistics()
    );
    const result = await StatisticsApi.getCampaignProductsStatistics(
      periodFrom,
      periodTo,
      campaignId,
      targetUserType,
      compare
    );

    if (isOk(result)) {
      dispatch(
        !compare
          ? fetchCampaignProductsStatisticsDone(result.value)
          : fetchCampaignComparisonProductsStatisticsDone(result.value)
      );
    } else {
      console.log(result.details);
      dispatch(
        !compare
          ? fetchCampaignProductsStatisticsDone([])
          : fetchCampaignComparisonProductsStatisticsDone([])
      );
    }
  } catch (error) {
    console.log(error);
  }
};
